import { verifyEmail, VerifyEmailPayload } from "@/api/email-verification";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export const useVerifyEmail = (
	options?: MutationOptionsWithoutFn<void, VerifyEmailPayload>,
) => {
	return useMutation({
		mutationFn: verifyEmail,
		...options,
	});
};
